import React, { useEffect } from 'react';
import { Loading } from './Loading';

export function NotFound(props) {
  useEffect(() => {
    window.location.href = '/';
  }, []);
  return <Loading />;
}
